import styled from 'styled-components'
import { Text } from '@lmc/ui-kit/src/general'
import { Avatar } from '@lmc/ui-kit'
import { useTranslation } from 'react-i18next'
import { NAMESPACE } from 'locale'
import { FormCard } from '@lmc/ui-kit'
import dayjs from 'dayjs'
import Divider from '@lmc/ui-kit/src/layout/Divider/Divider'
import { StockRecord } from '../../types'

type InitialStockDetailContentProps = {
  record: StockRecord
  medicationName: string
}

export const InitialStockDetailContent = ({
  record
}: InitialStockDetailContentProps) => {
  const { t } = useTranslation(NAMESPACE.EMAR_V2)

  const description = Array.isArray(record.notes)
    ? record.notes.join(', ')
    : record.notes || ''

  const initialStock = record.expectedStock ?? record.resultingStockLevel ?? 0
  const timeLogged = dayjs(record.date).format('DD-MM-YYYY HH:mm')
  const carerName = record.recordedBy.name || ''

  return (
    <SectionContainer>
      <FormCard level={2}>
        <InfoRow>
          <FullWidthSection>
            <StyledLabel level={2}>{t('DESCRIPTION')}</StyledLabel>
            <Text>{description || '-'}</Text>
          </FullWidthSection>
        </InfoRow>
        <RowDivider />
        <InfoRow>
          <InfoSection>
            <StyledLabel level={2}>{t('INITIAL_STOCK')}</StyledLabel>
            <Text weight="bold">
              {initialStock} {record.unit || ''}
            </Text>
          </InfoSection>
        </InfoRow>
        <RowDivider />
        <InfoRow>
          <InfoSection>
            <StyledLabel level={2}>{t('TIME_RECORDED')}</StyledLabel>
            <Text>{timeLogged}</Text>
          </InfoSection>
          <InfoSection>
            <StyledLabel level={2}>{t('RECORDED_BY')}</StyledLabel>
            <RecordedByContainer>
              <Avatar
                url={record.recordedBy.picture as unknown as string}
                size={16}
              />
              <Text>{carerName || '-'}</Text>
            </RecordedByContainer>
          </InfoSection>
        </InfoRow>
      </FormCard>
    </SectionContainer>
  )
}

const InfoRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 24px;
`

const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 184px;
`

const FullWidthSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const StyledLabel = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color5};
`

const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const RowDivider = styled(Divider)`
  margin: -8px 0;
`

const RecordedByContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`
